import { jsx as _jsx } from "react/jsx-runtime";
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import IconButton from './IconButton';
const ModalCloseButton = ({ containerStyle, onClick }) => {
    const style = `absolute right-3 top-3 h-12 w-12 ${containerStyle}`;
    return _jsx(IconButton, { Icon: faXmark, containerStyle: style, onClick: onClick });
};
export default ModalCloseButton;
